export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '434622a', dateTime: 1780422568504 };